import { render, staticRenderFns } from "./OtherApprove.vue?vue&type=template&id=3467d417"
import script from "./OtherApprove.vue?vue&type=script&lang=js"
export * from "./OtherApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports